import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { Advancedfilters } from "src/app/models/usuario-mantenimiento";
import { endpointsURL } from "src/app/constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class AdvancedFiltersService {
  env = environment.env;
  advancedFiltersURL = endpointsURL.advancedFiltersURL;

  constructor(private httpClient: HttpClient) {}

  public getCatalogo(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.advancedFiltersURL}catalogo`
    );
  }

  public saveFilters(dto: Advancedfilters[]): Observable<any> {
    return this.httpClient.put<any>(
      `${this.env}${this.advancedFiltersURL}saveFilters`,
      {
        filtros: dto,
      }
    );
  }

  public getAdvancedFiltersByUser(funcionalidad: string): Observable<any> {
    let params = new HttpParams().set("funcionalidad", funcionalidad);
    return this.httpClient.get<any>(
      `${this.env}${this.advancedFiltersURL}usuario`,
      {
        params: params,
      }
    );
  }

  renderFiltersOut(data, filtersListOutTable) {
    filtersListOutTable.forEach((element) => {
      const matchFilter = (e) => element.filterValue == e.id.ufFiltro;
      let index = data.findIndex(matchFilter);
      if (index > -1 && data[index].ufActivo == "S") {
        element.hide = false;
      } else {
        element.hide = true;
      }
    });
    filtersListOutTable.sort((a, b) => {
      return a.hide === b.hide ? 0 : a.hide ? 1 : -1;
    });
  
    if(filtersListOutTable.length > 5)
    {
      let auxArray = [];
      for (const item of filtersListOutTable) 
      {
        if(item.hide == false || auxArray.length < 5)
        {
          auxArray.push(item);
        }
      }
      filtersListOutTable = auxArray;
    }

    return filtersListOutTable;
  }
}
